import React from "react";

type PropsType = {
  color?: string;
  style?: React.CSSProperties;
  size?: number;
};

const ProPrimaryPricing = ({ size = 60, style = {} }: PropsType) => {
  return (
    <svg
      width={size}
      height={size}
      style={style}
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="60" height="60" fill="white" />
      <path
        d="M7.17373 10.3084C4.50134 13.067 3 16.8084 3 20.7097C3 40.003 22.9385 50.721 28.5476 53.3545C29.4805 53.7924 30.5195 53.7924 31.4524 53.3545C37.0615 50.721 57 40.003 57 20.7097C57 16.8084 55.4987 13.067 52.8263 10.3084C50.1539 7.54977 46.5293 6 42.75 6C38.9707 6 35.3461 7.54977 32.6737 10.3084C32.1175 10.8826 31.4368 11.8615 30.9015 12.6861C30.4849 13.328 29.5151 13.328 29.0985 12.6861C28.5632 11.8615 27.8825 10.8826 27.3263 10.3084C24.6539 7.54977 21.0293 6 17.25 6C13.4707 6 9.84612 7.54977 7.17373 10.3084Z"
        stroke="#003125"
        stroke-width="4"
      />
      <path
        d="M28.1877 22.8833C28.9059 21.3444 31.0941 21.3444 31.8123 22.8833L33.5108 26.5226C33.7095 26.9483 34.0517 27.2905 34.4774 27.4892L38.1167 29.1877C39.6556 29.9059 39.6556 32.0941 38.1167 32.8123L34.4774 34.5108C34.0517 34.7095 33.7095 35.0517 33.5108 35.4774L31.8123 39.1167C31.0941 40.6556 28.9059 40.6556 28.1877 39.1167L26.4892 35.4774C26.2905 35.0517 25.9483 34.7095 25.5226 34.5108L21.8833 32.8123C20.3444 32.0941 20.3444 29.9059 21.8833 29.1877L25.5226 27.4892C25.9483 27.2905 26.2905 26.9483 26.4892 26.5226L28.1877 22.8833Z"
        fill="url(#paint0_radial_107_42980)"
        stroke="#003125"
        stroke-width="4"
      />
      <defs>
        <radialGradient
          id="paint0_radial_107_42980"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(39.4067 21.5935) rotate(133.959) scale(23.6069 12.138)"
        >
          <stop stop-color="#EF89E4" />
          <stop offset="0.34862" stop-color="#BC5BEB" />
          <stop offset="0.584507" stop-color="#EF89E4" />
          <stop offset="0.965" stop-color="#BC5BEB" />
        </radialGradient>
      </defs>
    </svg>
  );
};

export default ProPrimaryPricing;
